import React from 'react'

import Box from 'components_new/atoms/Box'
import Text, { TextProps } from 'components_new/atoms/Text'

import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'

import { options } from './utils'

interface ContentfulRichTextRenderedProps {
  component?: TextProps['component']
  value: Document
  variant?: TextProps['variant']
  sx?: object
}

const ContentfulRichTextRendered = (props: ContentfulRichTextRenderedProps) => {
  const { component = 'div', value, variant = 'body1', sx } = props

  return (
    <Box sx={sx}>
      <Text component={component} variant={variant}>
        {documentToReactComponents(value, options)}
      </Text>
    </Box>
  )
}

export default ContentfulRichTextRendered
